import { Box, Grid, Typography } from "@mui/material";
import BreadCrumbs from "app/components/Breadcrumbs/Breadcrumbs";
import Layout from "app/layout/Layout";
import colors from "app/styles/colors";
import React from "react";

function AppHome() {
  return (
    <Layout>
      <Box
        sx={{ backgroundColor: colors.lightGray, p: 3, borderRadius: "12px" }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ bgcolor: colors.white, p: 2, borderRadius: "12px" }}
        >
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold" color="initial">
              App Management Section
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage="App Management Section" />
          </Grid>
        </Grid>

        <Box sx={{ mt: 2 }}></Box>
      </Box>
    </Layout>
  );
}

export default AppHome;
